import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CPays from './CPays'
import logo from '../common/logo.png'
import CInfoLangue from './CInfoLangue';

export default function CAcceuil() {
    const paysIni = useSelector(state => state.ComPays)    
    const regionIni = useSelector(state => state.ComRegion)
    const dispatch = useDispatch()
    const [select, setSelect] = useState("");
    const onSelect = (code) => setSelect(code);
    const[showpays, setShowpays]= useState(false)
      
      const actionbtn = (code) =>{        
        setShowpays(true);
      }
      const actionbtncacher = () =>{
         setShowpays(false)
      }
  
    return (
       <div className='row'>
            <div className='card  col-6 mx-auto'>
                <div className='card-body'>
                    <div className='card-title'></div>
                    <div className='card-text'>
                        <button className='btn btn-success' onClick={actionbtn}><i className="bi bi-gear"></i></button>
                        &nbsp;
                        <button className='btn btn-danger'  onClick={actionbtncacher}><i className="bi bi-eye-slash"></i></button>
                        { showpays && <CPays></CPays> }

                        
                       
                    </div>
                </div>
            </div>

            <div className='card  col-6 mx-auto border-0'>
                <div className='card-body'>
                    <div className='card-title'></div>
                    <div className='card-text'>                          
                        { paysIni.codepays !=null && regionIni.coderegion !=null &&
                              <CInfoLangue />
                        }
                        
                      
                        

                    </div>
                </div>
            </div>
       </div>
    )
  
}

